import  { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../../config.js";

ChartJS.register(
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement
);

const IncidentChart = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;
  const delayed = useRef(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/v1/healthAndSafetyJson`
        );
        const rawData = response.data.data.Data;
        
        const filteredData = rawData.filter(item => typeof item["__EMPTY"] === "number");

        
        const incidentCount = filteredData.reduce((acc, incident) => {
          const location = incident["__EMPTY_2"];
          acc[location] = (acc[location] || 0) + 1;
          return acc;
        }, {});

       
        const factoryLocations = ["Factory 1", "Factory 2", "Factory 3", "Factory 4"];
        const labels = factoryLocations;
        const data = labels.map(location => incidentCount[location] || 0);

      

        setChartData({
          labels,
          datasets: [
            {
              label: 'Number of Incidents',
              data: data,
              backgroundColor: 'rgba(75, 192, 192, 0.6)',
              borderColor: 'rgba(75, 192, 192, 1)',
               borderWidth: 1,
               
            },
          ],
        });
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!chartData) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  } else {
    const options = {
      responsive: true,
      scales: {
        x: {
          beginAtZero: true,
        },
        y: {
          beginAtZero: true,
        },
      },
      plugins: {
        legend: {
          display: true,
          labels: {
            color: 'white', 
            font: {
              size: 14 
            }
          }
        }
      },
      animation: {
        onComplete: () => {
          delayed.current = true;
        },
        delay: (context) => {
          let delay = 0;
          if (context.type === 'data' && context.mode === 'default' && !delayed.current) {
            delay = context.dataIndex * 300 + context.datasetIndex * 100;
          }
          return delay;
        },
      },
    };

    return (
      <div>
        <Box sx={{ backgroundColor: "#FF4D4D", padding: 2, borderRadius: 1 }}>
          <Typography variant="h5" sx={{ color: "#fff", textAlign: "center" }}>
            Injured Employees 
          </Typography>
        </Box>
        <Container>
          <div
            style={{
              padding: "20px",
              width: "100%",
              height: "80%",
            }}
          >
            <Bar
              data={chartData}
              options={options}
            />
          </div>
        </Container>
      </div>
    );
  }
};

export default IncidentChart;
